module.exports = __webpack_public_path__ + "static/media/gmail.6cd66d1a.png";